import './Min.css';
export var minValue = '_16mgjbd0-3-5-0';